import { useLocation } from 'react-router-dom';

export const ActiveNavLinkUrl = (path?:string, active?:string) => {
  const location = useLocation();
  return location.pathname === path ? (active ? active : true) : '';
};